import { AppActionType, SET_ACTIVE_FEATURES, SET_COMPANY, SET_TOKEN, SET_USER_ACCOUNT_INFO } from './actionTypes';
import { Company, UserAccountInfo } from 'client-experience-toolbox';

export interface AppState {
  company: Partial<Company>;
  activeFeatures: string[];
  userAccountInfo: UserAccountInfo;
  token: string;
}

export const defaultAppState: AppState = {
  company: {
    company_id: '',
    name: '',
  },
  activeFeatures: [],
  userAccountInfo: {
    firstname: '',
    lastname: '',
    phone: '',
    company: '',
    email: '',
    permissions: [],
    roles: [],
  },
  token: '',
};

export default (state = defaultAppState, action: AppActionType): AppState => {
  switch (action.type) {
    case SET_USER_ACCOUNT_INFO: {
      const { company, email, permissions, roles, firstname, lastname, phone } = action.userAccountInfo;
      return {
        ...state,
        userAccountInfo: {
          company,
          email,
          permissions,
          roles,
          firstname,
          lastname,
          phone,
        },
      };
    }
    case SET_TOKEN: {
      return { ...state, token: action.token };
    }
    case SET_ACTIVE_FEATURES: {
      return { ...state, activeFeatures: action.activeFeatures };
    }
    case SET_COMPANY: {
      return { ...state, company: action.company };
    }
    default:
      return state;
  }
};
